import React, { CSSProperties, FormEventHandler } from 'react'
import Flex, { IFlexProps } from 'typescript-styled-flex'

function Form({
  onSubmit,
  children,
  style,
  ...rest
}: IFormProps & IFormDispatch & IFlexProps) {
  const fill = style?.height != null
  return (
    <form onSubmit={onSubmit} style={{ width: '100%', ...style }}>
      <Flex
        full={true}
        column={true}
        style={
          fill
            ? {
                flex: 1,
                height: '100%',
                minHeight: 0,
                overflow: 'hidden',
                width: '100%',
              }
            : undefined
        }
        {...rest}
      >
        {children}
      </Flex>
    </form>
  )
}

export default Form

export interface IFormProps {
  children: React.ReactNode
  style?: CSSProperties
}

export interface IFormDispatch {
  onSubmit: FormEventHandler<HTMLFormElement>
}
